module.exports = __webpack_public_path__ + "static/media/mobileScreenshot01.b032878c.jpg";